import styled from 'styled-components';

const CardContent = styled.div`
  background-color: transparent;
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
`;

export default CardContent;
